module.exports = __webpack_public_path__ + "img/501_yw.back.46d730cd.jpg";